<template>
  <div class="py-14">
    <h1 class="font-bold text-center text-3xl">
      We’ve resent your {{ emailType }} email.
    </h1>
    <p class="text-center font-semibold">
      Please check your email for a new {{ emailType }} email to finish creating
      your account.
    </p>

    <div
      class="mt-10 w-full border border-on-surface-variant rounded-full min-h-10 flex items-center justify-center gap-2 text-on-surface-variant"
    >
      <Icon :size="IconSize.LG" :name="IconName.PROFILE_CIRCLE" />
      {{ props.modelValue }}
    </div>

    <Button
      label="Back to Sign in"
      :variant="ButtonVariant.TEXT"
      class="w-full mt-5"
      @click="emit('change-type', SelfRegisterType.SIGN_IN)"
    />
  </div>
</template>

<script setup lang="ts">
import {
  Button,
  ButtonVariant,
  Icon,
  IconName,
  IconSize,
} from '@exfluential/ui';
import { SelfRegisterType } from '~/api/auth';

type Props = {
  modelValue: string;
  emailType: string;
};
const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'change-type', value: SelfRegisterType): void;
}>();
</script>
